<!-- eslint-disable max-len -->
<template>
<div>
  <v-container fluid v-scroll="onScroll">
  <v-layout fluid v-if="event" fill-height>
    <v-flex xs12>
       <v-card shaped tile>
            <v-card-title class="time font-weight-light subtitle-1">
              <v-row cols="12">
                <v-col cols="6" v-if="event.ts">
                  <span v-if="event.ts">{{[event.ts] | moment('DD/MM', '–')}}</span><br/>
                  <span v-if="event.ts">
                    {{[event.ts, event.te] | moment('HH:mm', '–')}}
                  </span>
                </v-col>
                <v-col cols="5" v-if="0 === 1 && !$vuetify.breakpoint.smAndDown && event.type">
                  <div :style="{
                      'text-transform': 'uppercase',
                      padding: '8px',
                      display: 'table-cell',
                      backgroundColor: getEventColor(event, 'type').color,
                      color: getEventColor(event, 'type').text
                    }"
                >{{event.type}}</div></v-col>
              </v-row>
            </v-card-title>
            <v-card-title class="time font-weight-light subtitle-1"
              v-if="event.type"
            >
              <v-row cols="12">
                <v-col cols="11"><div :style="{
                      'text-transform': 'uppercase',
                      padding: '8px',
                      display: 'table-cell',
                      backgroundColor: getEventColor(event, 'type').color,
                      color: getEventColor(event, 'type').text
                    }"
                >{{event.type}}</div></v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row cols="12" v-if="event.zone || event.hall">
                <v-col :cols="$vuetify.breakpoint.smAndDown ? 11 : 6">
                <!-- :style="{color: event.colors.zone}"> -->
                  <div v-if="event.zone">
                    <v-icon class="pr-1">mdi-map-marker-radius-outline</v-icon>
                    {{event.zone}}
                  </div>
                  <div v-if="event.hall">Площадка {{event.hall}}</div>
                </v-col>
              </v-row>
              <v-row cols="12" v-if="linked_objects.length > 0" class="pb-2">
                <v-col cols="11">
                  <v-carousel hide-delimiters>
                    <v-carousel-item
                      v-for="(object) in linked_objects"
                      :key="object.id"
                    >
                      <div style="position: asolute; top: 0px; right: 0px; bottom: 0px; left: 0px;">
                        <!-- eslint-disable-next-line vuejs-accessibility/alt-text -->
                        <img  :src="object.image" width="100%" height="100%"
                              style="object-fit: contain; position: absolute; top: 0px; left: 0px;"
                        />
                        <div style="position: absolute; bottom: 0px;
                                    text-align: center; width: 100%;">
                          <div style="background-color: rgba(0,0,0,0.55);
                                      padding: 8px; color: white;
                                      display: inline-block;"
                          >
                            <a
                              v-if="object.href && object.href.length > 0"
                              target="_blank"
                              :href="object.href" style="color: white;"
                            >
                              {{  object.title }}
                              <v-icon color="white">mdi-open-in-new</v-icon>
                            </a>
                            <span v-else>{{ object.title }}</span>
                          </div>
                        </div>
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                </v-col>
              </v-row>
              <v-row cols="12">
                <v-col cols="11">
                  <div v-if="event.genre.length" class="genre font-weight-light">
                    {{event.genre}}
                  </div>
                  <div v-if="is_story" class="title font-weight-bold pt-2" v-html="event.title"></div>
                  <div v-if="!is_story" class="title font-weight-light pt-2" v-html="event.title"></div>
                </v-col>
              </v-row>
              <v-row cols="12">
                <v-col cols="11">
                  <social-sharing
                    :url="socialParams.url"
                    :title="socialParams.title"
                    :description="socialParams.quote"
                    :quote="socialParams.quote"
                    hashtags="КНИГИВГОРОДЕ_ТОБОЛЬСК-2024,КНИГИВГОРОДЕ_ТОБОЛЬСК,КНИГИВГОРОДЕ,ТОБОЛЬСК"
                    twitter-user=""
                    inline-template
                    v-if="$route.name === 'agenda' || event !== false"
                  >
                    <div>
                      <network
                        v-for="item in $store.state.socialNetworks"
                        :network="item.action"
                        :key="item.action"
                      >
                        <v-btn small text icon color="red"
                          :aria-label="'Поделиться: ' + item.action"
                        >
                          <font-awesome-icon :icon="item.icon" />
                        </v-btn>
                      </network>
                      <v-btn
                        small text icon color="red" :aria-label="'Скопировать адрес'"
                        @click="$copyText($getLocation())"
                      >
                        <font-awesome-icon :icon="['fas', 'link']" />
                      </v-btn>
                    </div>
                  </social-sharing>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row cols="12" v-if="event.description">
                <v-col cols="10">
                  <p class="subheading description font-weight-light">{{event.description}}</p>
                </v-col>
              </v-row>
              <v-layout row wrap class="pa-3" v-if="!is_story">
                <v-flex pt-3 pr-5 xs12 sm6 v-if="event.participants" class="font-weight-bold">
                  Участники:
                  <ul type="square">
                  <li
                    class="font-weight-light"
                    :key="item.name + item.desc"
                    v-for="item in event.participants"
                  >
                    <v-flex pt-3>
                      {{item.name}}
                      <span v-if="item.desc"><br/> {{item.desc}}</span>
                      <br v-if="item.roles && item.roles.length > 0"/>
                      <v-chip
                        class="text-caption text-lowercase"
                        color="orange"
                        right small
                        label
                        v-for="r in item.roles" v-bind:key="r">
                        {{ r }}
                      </v-chip>
                    </v-flex>
                  </li>
                  </ul>
                </v-flex>

                <v-flex pt-3 pr-5 xs12 sm6 v-if="event.organizer" class="font-weight-bold">
                  Организаторы:
                  <ul type="square">
                    <li class="font-weight-light" :key="item" v-for="item in event.organizer">
                      <v-flex pt-3>{{item}}</v-flex>
                    </li>
                  </ul>
                </v-flex>

                <v-flex pt-3 pr-5 xs12 sm6 v-if="event.tags.length > 0" class="font-weight-bold">
                  Теги:
                  <ul type="square">
                    <li class="font-weight-light" :key="item" v-for="item in event.tags">
                      <v-flex pt-3>{{item}}</v-flex>
                    </li>
                  </ul>
                </v-flex>

                <v-flex pt-3 pr-5 xs12 sm6 v-if="event.links.length > 0" class="font-weight-bold">
                  Ссылки:
                  <ul type="square">
                    <li class="font-weight-light" :key="item" v-for="item in event.links">
                      <v-flex pt-3 v-html="item"></v-flex>
                    </li>
                  </ul>
                </v-flex>

                <!--
                <v-flex pt-6 pr-5 xs12 sm6 class="font-weight-bold red--text"
                  v-if="!event.online"
                >
                  <div v-html="$t('message.ticketInfo')"></div>
                  <v-btn href="https://bookfestival.ru/tickets" target="_blank" small class="mt-2 white--text" color="red">Выбрать сеанс</v-btn>
                </v-flex> -->
              </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>
  <v-fade-transition>
      <v-btn
        fixed
        dark
        fab
        top
        right
        color="red"
        small
        @click="close($event, false)"
        aria-label="Закрыть"
        class="top"
      >
        <v-icon>close</v-icon>
      </v-btn>
  </v-fade-transition>
  </v-layout>
  </v-container>
        <v-fade-transition>
          <v-btn
            fixed
            dark
            fab
            bottom
            right
            color="red"
            :small="$vuetify.breakpoint.smAndDown"
            v-show="toptop"
            @click="toTop"
            aria-label="Наверх"
          >
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-fade-transition>
</div>
</template>

<script>
import Axios from 'axios';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      id: false,
      agenda: false,
      event: false,
      toptop: false,
      linked_objects: [],
      is_story: false,
    };
  },
  computed: {
    ...mapState(['applicationTitle', 'filters']),
    socialParams() {
      const title = [];
      const quote = [];
      const what = [this.applicationTitle];
      const { filters } = this;
      const { event } = this;

      let day = filters.days || '';
      if (day && Array.isArray(day)) [day] = day;
      if (event) {
        day = window.moment(event.ts).utcOffset('+0500');
        if (day.isValid()) {
          day = day.format('DD/MM HH:mm');
        } else {
          day = false;
        }
      }
      if (day) title.push(day);

      if (event) {
        title.push(event.title);
        if (day) quote.push(`Когда: ${day}`);
        what.push(event.title);
        quote.push(`Что: ${what.join(', ')}`);
        if (event.place && event.place.title) quote.push(`Где: ${event.place.title}`);
      }

      title.push(this.applicationTitle);
      return {
        title: title.join(', '),
        url: window.location.toString(),
        quote: quote.join('\n'),
      };
    },
  },
  mounted() {
    const self = this;
    this.$store.dispatch('updateEvents');
    self.id = this.$route.params.event;
    Axios
      .get(`/api/events/v2/tobolsk/2024-summer/${self.id}`, {
        params: {
          lang: self.$i18n.locale,
        },
      })
      .then((res) => {
        let event = false;
        if (res.data && res.data.events && Array.isArray(res.data.events)) {
          event = res.data.events.length > 0 ? res.data.events[0] : false;
        }

        if (!event) throw new Error();
        self.agenda = res.data;
        self.event = event;

        // event.title = event.title.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');
        const covers = (event.linked_objects || [])
          .filter((e) => e.is_cover)
          .map((e) => e.image);
        event.hasCover = !!covers[0] && process.env.VUE_APP_SHOW_COVER === 'yes';
        event.cover = covers[0] || false;
        this.linked_objects = event.linked_objects || [];

        self.is_story = (event.formats || []).indexOf('story') !== -1;

        event.participants = event.participants.sort((a, b) => {
          if (!a.roles && !b.roles) return 0;
          if (a.roles && !b.roles) return -1;
          if (!a.roles && b.roles) return 1;
          return 0;
        });
        self.$store.dispatch('updateCurrentEvent', event);
        if (event.organizer) {
          event.organizer = event.organizer.split(';');
        } else {
          event.organizer = false;
        }
        if (event.participants && Array.isArray(event.participants)) {
          event.participants = event.participants.length > 0 ? event.participants : false;
        } else {
          event.participants = false;
        }
        if (process.env.NODE_ENV !== 'development') {
          // eslint-disable-next-line max-len
          this.$gtag.event('show_event', { event_category: 'engagement', event_label: `${event.title} - ${this.$route.fullPath}` });
        }
      })
      .catch(() => {
        self.close(false, true);
      });
  },
  methods: {
    close(event, toHome) {
      if (this.$store.state.initial === false) {
        const nav = {
          path: '/events/',
          query: this.$store.getters.filtersQuery,
          // hash: this.$route.params.event,
        };
        if (toHome) {
          delete nav.query;
          delete nav.hash;
          this.$store.dispatch('updateLoadCount', 0);
          const { filters } = this;
          Object.keys(filters).forEach((key) => {
            filters[key] = false;
          });
          this.$router.push(nav);
        } else {
          this.$router.replace(nav);
        }
      } else {
        this.$router.go(-1);
      }
    },
    onScroll: (() => {
      let tm = false;
      return function scroll(e) {
        const self = this;
        window.clearTimeout(tm);
        tm = window.setTimeout(() => {
          if (typeof window === 'undefined') return;
          const top = window.pageYOffset || e.target.scrollTop || 0;
          self.toptop = top > 40;
        }, 250);
      };
    })(),
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  beforeDestroy() {
    this.$store.dispatch('updateCurrentEvent', false);
  },
};
</script>

<style lang="scss" scoped>

.about {
  position: absolute;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
  overflow: hidden;
}
.title {
  white-space: pre-line;
  font-size: 16px;
  line-height: 18px;
  margin: 0px 0px 0px 0px;
  padding: 9px 0px 9px 0px;
}
.genre {
  white-space: pre-line;
  font-size: 16px;
  line-height: 18px;
  margin: 0px 0px 0px 0px;
  padding: 9px 0px 9px 0px;
}
.description {
  white-space: pre-line;
  font-size: 16px;
}
.top {
  top: var(--headerHeight);
  right: 4px;
}
.cover {
  max-width: 560px !important;
}
</style>
<style>
  .v-card__text, .v-card__title {
    word-break: normal !important; /* maybe !important  */
  }
</style>
